import { StatusDot } from '../../ui/StatusDot';
import { useUiStore } from '../../../store/ui.store';

const ROWS = [
  { label: 'System Status', value: 'All systems normal' },
  { label: 'Data Connection', value: 'MQTT Broker · Connected' },
];

export function SidebarFooterStatus() {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);
  if (collapsed) return null;

  return (
    <div className="mt-3 border-t border-border px-2 pb-0.5 pt-3">
      <div className="space-y-1">
        {ROWS.map((row) => (
          <div className="flex items-center gap-1.5" key={row.label}>
            <StatusDot status="ok" size={6} />
            <p className="truncate text-[10.5px] text-text-secondary">
              {row.label} · <b className="text-text-primary">{row.value}</b>
            </p>
          </div>
        ))}
      </div>
      <p className="mt-1 truncate text-[9.5px] text-text-tertiary">© 2026 AquaRefine™ · v0.1.0</p>
    </div>
  );
}
